import { render, staticRenderFns } from "./ConfirmationEmailEditStage.vue?vue&type=template&id=1160fbbc&scoped=true"
import script from "./ConfirmationEmailEditStage.vue?vue&type=script&lang=js"
export * from "./ConfirmationEmailEditStage.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationEmailEditStage.vue?vue&type=style&index=0&id=1160fbbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1160fbbc",
  null
  
)

export default component.exports